var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from "react";
import { patchRol } from "../../../resources/helper/rol";
import { useDispatch } from "react-redux";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var useRolManagement = function (setTrigger, setSeeToast) {
    var _a = useState(false), loadingSaveRolPermissions = _a[0], setLoadingSaveRolPermissions = _a[1];
    var _b = useState(false), openDrawerRolList = _b[0], setOpenDrawerRolList = _b[1];
    var _c = useState(false), openDrawerEdit = _c[0], setOpenDrawerEdit = _c[1];
    var _d = useState([]), permissions = _d[0], setPermissions = _d[1];
    var _e = useState(""), assignedQuery = _e[0], setAssignedQuery = _e[1];
    var _f = useState(""), availableQuery = _f[0], setAvailableQuery = _f[1];
    var _g = useState([]), assignedPermissionsToEdit = _g[0], setAssignedPermissionsToEdit = _g[1];
    var _h = useState([]), assignedPermissionsToEditFiltered = _h[0], setAssignedPermissionsToEditFiltered = _h[1];
    var _j = useState([]), permissionAvailableToAssign = _j[0], setPermissionAvailableToAssign = _j[1];
    var _k = useState([]), permissionAvailableToAssignFiltered = _k[0], setPermissionAvailableToAssignFiltered = _k[1];
    var _l = useState(null), selectedRol = _l[0], setSelectedRol = _l[1];
    var dispatch = useDispatch();
    var handleOpenDrawerRolList = function (item) {
        var _a;
        setSelectedRol(item);
        var permissions = ((_a = item.permission) === null || _a === void 0 ? void 0 : _a.map(function (permission) { return ({
            id: permission.id || "",
            name: permission.name || "",
            description: permission.description || "",
        }); })) || [];
        setAssignedPermissionsToEdit(permissions);
        setAssignedPermissionsToEditFiltered(permissions);
        setOpenDrawerRolList(true);
    };
    var handleOpenDrawerEdit = function (item) {
        var _a;
        setOpenDrawerEdit(true);
        setSelectedRol(item);
        var permissions = ((_a = item.permission) === null || _a === void 0 ? void 0 : _a.map(function (permission) { return ({
            id: permission.id || "",
            name: permission.name || "",
            description: permission.description || "",
        }); })) || [];
        setAssignedPermissionsToEdit(permissions);
        setAssignedPermissionsToEditFiltered(permissions);
    };
    var onSearchAvailableToAssign = function (value) {
        setAvailableQuery(value);
        setPermissionAvailableToAssignFiltered(permissionAvailableToAssign.filter(function (permission) {
            return permission.name.toLowerCase().includes(value.toLowerCase());
        }));
    };
    var onSearchAssignedToEdit = function (value) {
        setAssignedQuery(value);
        setAssignedPermissionsToEditFiltered(assignedPermissionsToEdit.filter(function (permission) {
            return permission.name.toLowerCase().includes(value.toLowerCase());
        }));
    };
    var handlePermissionAvailableToAssign = function (permissions) {
        var permissionsFiltered = permissions.map(function (permission) { return ({
            id: permission.id || "",
            name: permission.name || "",
            description: permission.description || "",
        }); });
        setPermissionAvailableToAssign(permissionsFiltered);
        setPermissionAvailableToAssignFiltered(permissionsFiltered);
    };
    var onRoleMove = function (itemId, from, to) {
        if (from === "available" && to === "assigned") {
            var itemToMove = permissionAvailableToAssign.find(function (permission) { return permission.id === itemId; });
            if (itemToMove) {
                // Update assigned permissions
                var newAssignedPermissions = __spreadArray(__spreadArray([], assignedPermissionsToEdit, true), [
                    itemToMove,
                ], false);
                setAssignedPermissionsToEdit(newAssignedPermissions);
                setAssignedPermissionsToEditFiltered(newAssignedPermissions.filter(function (permission) {
                    return permission.name.toLowerCase().includes(assignedQuery.toLowerCase());
                }));
                // Update available permissions
                var newAvailablePermissions = permissionAvailableToAssign.filter(function (permission) { return permission.id !== itemId; });
                setPermissionAvailableToAssign(newAvailablePermissions);
                setPermissionAvailableToAssignFiltered(newAvailablePermissions.filter(function (permission) {
                    return permission.name.toLowerCase().includes(availableQuery.toLowerCase());
                }));
            }
        }
        else if (from === "assigned" && to === "available") {
            var itemToMove = assignedPermissionsToEdit.find(function (permission) { return permission.id === itemId; });
            if (itemToMove) {
                // Update assigned permissions
                var newAssignedPermissions = assignedPermissionsToEdit.filter(function (permission) { return permission.id !== itemId; });
                setAssignedPermissionsToEdit(newAssignedPermissions);
                setAssignedPermissionsToEditFiltered(newAssignedPermissions.filter(function (permission) {
                    return permission.name.toLowerCase().includes(assignedQuery.toLowerCase());
                }));
                // Update available permissions
                var newAvailablePermissions = __spreadArray(__spreadArray([], permissionAvailableToAssign, true), [
                    itemToMove,
                ], false);
                setPermissionAvailableToAssign(newAvailablePermissions);
                setPermissionAvailableToAssignFiltered(newAvailablePermissions.filter(function (permission) {
                    return permission.name.toLowerCase().includes(availableQuery.toLowerCase());
                }));
            }
        }
    };
    var onRoleDelete = function (itemId) {
        var itemToMove = assignedPermissionsToEdit.find(function (permission) { return permission.id === itemId; });
        if (itemToMove) {
            // Update assigned permissions
            var newAssignedPermissions = assignedPermissionsToEdit.filter(function (permission) { return permission.id !== itemId; });
            setAssignedPermissionsToEdit(newAssignedPermissions);
            setAssignedPermissionsToEditFiltered(newAssignedPermissions.filter(function (permission) {
                return permission.name.toLowerCase().includes(assignedQuery.toLowerCase());
            }));
            // Update available permissions
            var newAvailablePermissions = __spreadArray(__spreadArray([], permissionAvailableToAssign, true), [
                itemToMove,
            ], false);
            setPermissionAvailableToAssign(newAvailablePermissions);
            setPermissionAvailableToAssignFiltered(newAvailablePermissions.filter(function (permission) {
                return permission.name.toLowerCase().includes(availableQuery.toLowerCase());
            }));
        }
    };
    var onSaveRolPermissions = function (permissions) { return __awaiter(void 0, void 0, void 0, function () {
        var body, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        id: selectedRol === null || selectedRol === void 0 ? void 0 : selectedRol.id,
                        name: selectedRol === null || selectedRol === void 0 ? void 0 : selectedRol.code,
                        description: selectedRol === null || selectedRol === void 0 ? void 0 : selectedRol.type,
                        permissions: permissions.map(function (permission) { return permission.id; }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoadingSaveRolPermissions(true);
                    return [4 /*yield*/, patchRol(body, (selectedRol === null || selectedRol === void 0 ? void 0 : selectedRol.id) || "")];
                case 2:
                    _a.sent();
                    setTrigger(true);
                    setSeeToast({
                        show: true,
                        type: typeAlert.success,
                        message: "Rol actualizado correctamente",
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setSeeToast({
                        show: true,
                        type: typeAlert.error,
                        message: "Error al actualizar el rol",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingSaveRolPermissions(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        loadingSaveRolPermissions: loadingSaveRolPermissions,
        openDrawerRolList: openDrawerRolList,
        setOpenDrawerRolList: setOpenDrawerRolList,
        openDrawerEdit: openDrawerEdit,
        setOpenDrawerEdit: setOpenDrawerEdit,
        permissions: permissions,
        setPermissions: setPermissions,
        assignedPermissionsToEdit: assignedPermissionsToEdit,
        selectedRol: selectedRol,
        setSelectedRol: setSelectedRol,
        handleOpenDrawerRolList: handleOpenDrawerRolList,
        handleOpenDrawerEdit: handleOpenDrawerEdit,
        handlePermissionAvailableToAssign: handlePermissionAvailableToAssign,
        permissionAvailableToAssign: permissionAvailableToAssign,
        permissionAvailableToAssignFiltered: permissionAvailableToAssignFiltered,
        assignedPermissionsToEditFiltered: assignedPermissionsToEditFiltered,
        onSearchAvailableToAssign: onSearchAvailableToAssign,
        onSearchAssignedToEdit: onSearchAssignedToEdit,
        assignedQuery: assignedQuery,
        availableQuery: availableQuery,
        onRoleMove: onRoleMove,
        onRoleDelete: onRoleDelete,
        onSaveRolPermissions: onSaveRolPermissions,
    };
};
